import React from 'react';

interface IArrowRightProps {
	size?: string;
	fill?: string;
	className?: string;
	strokeWidth?: string;
}

export const ArrowRight = ({ size = '24', className = '', fill, strokeWidth = '2' }: IArrowRightProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none" className={className}>
			<path
				d="M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
				stroke={fill || '#3D3D3D'}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M16.5833 12L6.58334 12"
				stroke={fill || '#3D3D3D'}
				strokeWidth={strokeWidth}
				strokeLinejoin="round"
			/>
			<path
				d="M12 7.41669L16.5833 12L12 16.5834"
				stroke={fill || '#3D3D3D'}
				strokeWidth={strokeWidth}
				strokeLinejoin="round"
			/>
		</svg>
	);
};
